import React, {Component} from 'react';
import {Link} from "react-router-dom";
import FocusPageId from "../../FocusPageId";
import '../Beginners.css'
class CustomsRequirementsTopics extends React.Component {
    constructor(props){
        super(props);

        this.focusPage = this.focusPage.bind(this);

    }

    focusPage =(elementId)=>{
        FocusPageId.selectedId={elementId}
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }
    render() {

        return (
            <div className="static-pages">
                <div className="background-div">
                    <h3><b><span>輸入関税要件について</span></b></h3>
                     <div className="brElement"></div>

                    <div onClick={()=>this.focusPage("a")}>
                        <Link to='/customsrequirements'>
                            <h4><b  className="reduce-font-size cart-row-text-color"> 輸入手続きが必要ですか？</b>
                            </h4>
                        </Link>

                    </div>
                    {/*<div className='col-md-10'></div>*/}
                    <div className='faq-link-float-right   col-12-custom'>
                        <Link to="/frequent">
                            <span className='font-size-20 reduce-font-size'>
                            戻る
                            </span>
                        </Link>
                    </div>
                </div>

            </div>
        );
    }
}

export default CustomsRequirementsTopics;




// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/LinkPages/FaqTopicsPages/CustomsRequirementsTopics.js